import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Check } from "lucide-react";
import { Reveal } from "./motion";

const Side = ({ id, k, title, img, alt, points, flip }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div id={id} ref={ref} className="grid scroll-mt-24 items-center gap-10 lg:grid-cols-12 lg:gap-16">
      <div className={`relative lg:col-span-6 ${flip ? "lg:order-2" : ""}`}>
        <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem]" style={{ clipPath: flip ? "polygon(0 0, 100% 6%, 100% 100%, 0 94%)" : "polygon(0 6%, 100% 0, 100% 94%, 0 100%)" }}>
          <motion.img style={{ y, scale: 1.18 }} src={img} alt={alt} className="h-full w-full object-cover grayscale contrast-125" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E1A] via-transparent to-transparent" />
          <div className="absolute inset-0 bg-[#39FF14]/10 mix-blend-color" />
        </div>
        <span className="absolute -bottom-6 left-6 font-display text-[8rem] font-black leading-none text-[#39FF14] sm:text-[10rem]">{k}</span>
      </div>
      <Reveal className={`lg:col-span-6 ${flip ? "lg:order-1" : ""}`}>
        <p className="font-mono-gd text-xs uppercase tracking-[0.3em] text-[#39FF14]">For {id}</p>
        <h3 className="mt-4 font-display text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl">{title}</h3>
        <ul className="mt-8 space-y-4">
          {points.map((p) => (
            <li key={p} className="flex items-start gap-4 border-b border-white/5 pb-4 text-slate-300">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#39FF14]/15 text-[#39FF14]"><Check className="h-3.5 w-3.5" /></span>{p}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  );
};

export const Sides = () => (
  <section className="relative mx-auto max-w-[1400px] space-y-32 px-5 py-28 sm:px-10 sm:py-36">
    <Side id="coaches" k="C" title={<>Run the program<br />from the bench.</>} img="/img/team.jpg" alt="High school game in a packed gym"
      points={["Roster cards with height, GPA and recruiting interest", "Season splits by date range, game logs and shot zones", "Combine sessions, goals, drills and attendance", "Read every recruiter note and reply in one inbox"]} />
    <Side id="recruiters" k="R" flip title={<>Scout every<br />GAMEDAY team.</>} img="/img/jump.jpg" alt="Player elevating for a jump shot"
      points={["Search prospects across every team on GAMEDAY", "Tag your board: Top Target, Monitoring, Backup", "Full dossier: season, zones, combine vs. NBA averages", "Private notes and direct messages to the coach"]} />
  </section>
);
